import { getIdPhotoRef, getPhotoUrl, isCertifPending } from '@/lib/utils.ts';
import BadgeUserPendingCertification from '../BadgeUserPendingCertification';
import ImgUserPicture from '../ImgUserPicture';
import { IHasCertification } from '.';

const UserCertificationItemPhoto = ({ certification }: IHasCertification) => (
	<div className={'flex justify-center h-[270px] max-w-[420px] relative'}>
		<ImgUserPicture
			enableFullScreen
			className='w-1/2 object-cover rounded-tl-md cursor-pointer'
			alt='verification-image'
			src={getPhotoUrl(certification?.urls[0])} />
		<img
			alt='verification-ref'
			src={getIdPhotoRef(certification?.verificationSourceImage)}
			className='w-1/2 object-cover rounded-tr-md' />
		{
			isCertifPending({ id: certification?.userData?.verifications?.id }) &&
			<span className={'absolute top-2 right-1/2'}>
				<BadgeUserPendingCertification
					mode='banner'
					forceDisplay />
			</span>
		}
	</div>
);

export default UserCertificationItemPhoto;

